const DELAY = 500;

class ClickManager {
  constructor() {
    this.element = null
    this.vm = null
    this.timer = 0;
    this.prevent = false;
    this.onClick = this.onClick.bind(this)
    this.onDoubleClick = this.onDoubleClick.bind(this)
  }
  initialize(vm, element) {
    this.vm = vm
    this.element = element
    this.element.addEventListener('click', this.onClick)
    this.element.addEventListener('dblclick', this.onDoubleClick)
  }
  destroy() {
    this.element.removeEventListener('click', this.onClick)
    this.element.removeEventListener('dblclick', this.onDoubleClick)
  }
  onClick() {
    let { vm } = this
    this.timer = setTimeout(() => {
      if (!this.prevent) {
        vm.$emit('z-click', vm)
      }
      this.prevent = false;
    }, DELAY);
  }
  onDoubleClick() {
    let { vm } = this
    clearTimeout(this.timer);
    this.prevent = true;
    vm.$emit('z-dblclick', vm)
  }
}

export default ClickManager